import { render } from "./EquivalentProducts.vue?vue&type=template&id=69c07898"
import script from "./EquivalentProducts.vue?vue&type=script&lang=js"
export * from "./EquivalentProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__